<div class="container">
  <div class="arrow-up"></div>
  <div  class="speech-bubble">
    <p class="header" *ngIf="header !== null" [innerText]="header"></p>
    <div [ngClass]='{single: forceSingleColumnTooltip}'
         class="speech-bubble-content" *ngFor="let para of 'eeoc-form.' + detailsName + '-details' | translate | keyvalue">
      <p *ngIf="isString(para.value)" [innerHtml]="para.value"></p>
      <div class="tooltip-section" *ngIf="isObject(para.value)">
        <p class="subitem" *ngFor="let key of keys(para.value)">
          {{para.value[key]}}
        </p>
      </div>
    </div>

  </div>
</div>
